import React from 'react';

const TableD = (props) => <td className="px-3 py-2" {...props} />;

export default TableD;
